<section class="au-checklist-section">
	<div class="checklist-section-header">
		<div class="section-name-wrapper">
			<p class="section-name">{{ 'checklist' | translate }}</p>
			<div class="completed-total">
				{{ completedAmount }} / {{ checklistData.length }}
			</div>
		</div>

		<button (click)="addChecklist()" class="au-add-fab-button mat-fab--p0">
			<mat-icon class="accent-icon" svgIcon="add"></mat-icon>
		</button>
	</div>

	<div class="checklist-progress-bar">
		<checklist-progress-bar [percentage]="completedPercentage"></checklist-progress-bar>
	</div>

	<div class="check-list">
		@for (item of checklistData; track item) {
			<div class="checklist-item-wrapper">
				<checklist-item [checklistItem]="item"></checklist-item>
			</div>
		}
		<div class="checklist-input">
			<checklist-input (itemSubmitted)="addNewChecklistItem($event)"></checklist-input>
		</div>
	</div>
</section>
